import React from "react";
import Options from "../options/Options";

import style from "./Question.module.css";

import "katex/dist/katex.min.css";
import Latex from "react-latex-next";

function Question({ question, dispatch, answer, hasAnswered }) {
	return (
		<div className={style.questionHolder}>
			{/* <h4>{question.question}</h4> */}
			<h4>
				<Latex>{question.question || ""}</Latex>
			</h4>
			<Options
				hasAnswered={hasAnswered}
				dispatch={dispatch}
				answer={answer}
				question={question}
			/>
		</div>
	);
}

export default Question;
